export default Object.freeze({
    XS: 767,
    SM: 992,
    MD: 1200,
})
